import { getJSendErrorMessages } from 'clickNgo/helpers/api'
import { fail } from 'onboarding/classes/services/notification'
import { convertErrorMessagesToHTMLList } from 'onboarding/utils/convertErrorMessagesToHTMLList'

export const handleFailResponse = (data: unknown) => {
  fail(convertErrorMessagesToHTMLList(getJSendErrorMessages({ status: 'fail', data })))
}

export const handleErrorResponse = (message: string | undefined) => {
  const errorMessages = message ? [message] : []
  if (errorMessages.length) {
    fail(convertErrorMessagesToHTMLList(errorMessages))
  }
}
